<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="ded"> </p>
<p class="DED"><span class="ePub-I">To Katherine Anderton because I owe you one</span></p>
<p class="DED"><span class="ePub-I">Special thanks to my helpful readers<br/>Molly Kilpatrick and Margaret Davis</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?69437e4c